import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Instagram } from "lucide-react";

const SERVICES = [
    { label: "Création de site", href: "#services" },
    { label: "SEO local", href: "#services" },
    { label: "Identité visuelle", href: "#services" },
];
const METIERS = [
    { label: "Plombiers", href: "#services" },
    { label: "Couvreurs", href: "#services" },
    { label: "Électriciens", href: "#services" },
    { label: "Menuisiers", href: "#services" },
    { label: "Maçons", href: "#services" },
];
const AGENCE = [
    { label: "Méthode", href: "#methode" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "#contact" },
];

export default function Footer() {
    const openCookies = (e) => {
        e.preventDefault();
        if (typeof window !== "undefined" && typeof window.__alvaOpenCookies === "function") {
            window.__alvaOpenCookies();
        }
    };

    return (
        <footer
            className="relative bg-[#1A2F6E] text-white/80 pt-20 pb-10"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                    {/* Brand column */}
                    <div className="col-span-2 md:col-span-1">
                        <div className="font-display text-2xl font-bold lowercase text-white tracking-tight">
                            alva digital
                        </div>
                        <p className="mt-4 text-sm text-white/55 leading-relaxed max-w-xs">
                            Agence web parisienne pour artisans. On fait des sites qui génèrent des devis, pas des cartes de visite.
                        </p>
                        <ul className="mt-6 space-y-3 text-sm">
                            <li className="flex items-center gap-3">
                                <Mail size={14} className="text-[#2B7BE4]" />
                                <a href="mailto:contact@alvadigital.fr" className="hover:text-white">
                                    contact@alvadigital.fr
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone size={14} className="text-[#2B7BE4]" />
                                <a href="tel:+33769300943" className="hover:text-white">
                                    07 69 30 09 43
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={14} className="text-[#2B7BE4] mt-0.5" />
                                <span>Paris, France</span>
                            </li>
                        </ul>
                        <div className="mt-6 flex items-center gap-2">
                            <a
                                href="#"
                                aria-label="LinkedIn"
                                className="inline-flex size-9 items-center justify-center rounded-full bg-white/5 border border-white/10 hover:bg-[#2B7BE4] hover:border-[#2B7BE4] transition-colors"
                                data-testid="social-linkedin"
                            >
                                <Linkedin size={14} />
                            </a>
                            <a
                                href="#"
                                aria-label="Instagram"
                                className="inline-flex size-9 items-center justify-center rounded-full bg-white/5 border border-white/10 hover:bg-[#2B7BE4] hover:border-[#2B7BE4] transition-colors"
                                data-testid="social-instagram"
                            >
                                <Instagram size={14} />
                            </a>
                        </div>
                    </div>

                    <FooterCol title="Services" items={SERVICES} testId="footer-services" />
                    <FooterCol title="Métiers" items={METIERS} testId="footer-metiers" />
                    <FooterCol title="Alva digital" items={AGENCE} testId="footer-agence" />
                </div>

                {/* Legal links row */}
                <nav
                    className="mt-14 pt-8 border-t border-white/10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/55"
                    aria-label="Liens légaux"
                    data-testid="footer-legal-links"
                >
                    <Link to="/mentions-legales" className="min-h-[44px] inline-flex items-center hover:text-white transition-colors" data-testid="footer-link-mentions">
                        Mentions légales
                    </Link>
                    <span aria-hidden className="text-white/20">|</span>
                    <Link to="/politique-confidentialite" className="min-h-[44px] inline-flex items-center hover:text-white transition-colors" data-testid="footer-link-confidentialite">
                        Politique de confidentialité
                    </Link>
                    <span aria-hidden className="text-white/20">|</span>
                    <Link to="/cgv" className="min-h-[44px] inline-flex items-center hover:text-white transition-colors" data-testid="footer-link-cgv">
                        CGV
                    </Link>
                    <span aria-hidden className="text-white/20">|</span>
                    <a href="#cookies" onClick={openCookies} className="min-h-[44px] inline-flex items-center hover:text-white transition-colors" data-testid="footer-link-cookies">
                        Cookies
                    </a>
                </nav>

                <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
                    <p>© 2026 Alva Digital. Tous droits réservés.</p>
                    <p>
                        Fait à Paris avec attention · <span className="text-[#2B7BE4]">design qui convertit</span>
                    </p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, items, testId }) {
    return (
        <div data-testid={testId}>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">
                {title}
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
                {items.map((it) => (
                    <li key={it.label}>
                        <a href={it.href} className="text-white/55 hover:text-white transition-colors">
                            {it.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
